import { render, staticRenderFns } from "./logo-dialog.vue?vue&type=template&id=71f3d2e6&"
import script from "./logo-dialog.vue?vue&type=script&lang=js&"
export * from "./logo-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports